<template>
  <footer class="footer">
    <p>&copy; {{ thisYear }} RAKSUL INC.</p>
  </footer>
</template>

<script>

export default {
  name: 'Footer',
  computed: {
    thisYear: function () {
      let today = new Date()
      return today.getFullYear()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  margin: 7.2rem 0;
}

.footer p {
  text-align: center;
  font-size: var(--normal-font-size);
  color: var(--davys-gray);
}

</style>



// WEBPACK FOOTER //
// src/components/Molecules/Footer.vue